import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequiredText, isEmail, isAllowedEmailDomain, strMax, } from '@/utils/validate/conditions';
import { isInteger } from '@/utils/validate/conditions/integer';
/*
 * ================================
 * メール関連
 * ================================
 */
/**
 * validation: メールアドレス
 */
export const validateEmail = composeValidators(isRequiredText('メールアドレスを入力してください'), isEmail('メールアドレス形式が正しくありません'), isAllowedEmailDomain('フリーメールアドレスは使用できません'));
/**
 * validation: 電話番号
 */
export const validatePhoneNumber = composeValidators(isRequiredText('電話番号を入力してください'), strMax(4, '桁が多すぎます。入力内容をご確認ください'), isInteger('半角数字で入力してください'));
/**
 * validation: メールアドレス（フリーアドレス許可）
 */
export const validateEmailAllowFree = composeValidators(isRequiredText('メールアドレスを入力してください'), isEmail('メールアドレス形式が正しくありません'));
/*
 * ================================
 * 名前関連
 * ================================
 */
/**
 * validation: 姓
 */
export const validateLastName = composeValidators(isRequiredText('姓を入力してください'), strMax(20, '姓は20文字以内で入力してください'));
/**
 * validation: 名
 */
export const validateFirstName = composeValidators(isRequiredText('名を入力してください'), strMax(20, '名は20文字以内で入力してください'));
